var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "modal",
        "fade",
        "modal-upload-default",
        _vm.active ? "show" : ""
      ],
      style: _vm.active ? "display: block;" : "",
      attrs: {
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "myModalLabel"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          staticStyle: { "z-index": "1041 !important" },
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "button",
                {
                  staticClass: "modal-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: { click: _vm.close }
                },
                [_c("i", { staticClass: "font-icon-close-2" })]
              ),
              _vm._v(" "),
              _c("h4", { staticClass: "modal-title" }, [_vm._v("Upload File")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-upload" }, [
              _c("div", { staticClass: "modal-upload-cont" }, [
                _c("div", { staticClass: "tab-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tab-pane active",
                      attrs: { role: "tabpanel", id: "tab-upload" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "modal-upload-body scrollable-block",
                          staticStyle: { height: "inherit" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "uploading-container" },
                            [
                              _c(
                                "drop",
                                {
                                  on: {
                                    dragleave: _vm.onDragLeave,
                                    dragover: _vm.onDragOver,
                                    drop: _vm.onFileDropped
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "drop-zone",
                                        _vm.isDragging ? "dragover" : ""
                                      ],
                                      staticStyle: { width: "initial" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "font-icon font-icon-cloud-upload-2"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "drop-zone-caption" },
                                        [_vm._v("Drag file to upload")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "btn btn-rounded btn-file btn-sm"
                                        },
                                        [
                                          _c("span", [_vm._v("Choose file")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticStyle: {
                                              left: "-330px",
                                              top: "-130px"
                                            },
                                            attrs: {
                                              type: "file",
                                              multiple: ""
                                            },
                                            on: { change: _vm.onFileSelected }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mt-3" }, [
                                        _c("hr", {
                                          staticClass: "m-auto",
                                          staticStyle: { width: "75%" }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "drop-zone-caption mt-2"
                                          },
                                          [_vm._v("Or input image url here")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input-group w-50 m-auto"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.imageUrl,
                                                  expression: "imageUrl"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: { type: "url" },
                                              domProps: { value: _vm.imageUrl },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.imageUrl =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-append"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-outline-secondary",
                                                    attrs: {
                                                      type: "button",
                                                      disabled: !_vm.imageUrl
                                                    },
                                                    on: {
                                                      click: _vm.fetchImage
                                                    }
                                                  },
                                                  [_vm._v("Upload")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "uploading-container-in" },
                                [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "uploading-list list-unstyled mb-0"
                                    },
                                    [
                                      _vm._l(_vm.files, function(file) {
                                        return _c(
                                          "li",
                                          {
                                            staticClass: "uploading-list-item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "uploading-list-item-wrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uploading-list-item-name"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "font-icon font-icon-cam-photo"
                                                    }),
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(file.name) +
                                                        "\n                                                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uploading-list-item-size"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getFileSize(
                                                          file.size
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "uploading-list-item-close",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeFile(
                                                          file.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "font-icon-close-2"
                                                    })
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "progress" },
                                              [
                                                _c("span", {
                                                  staticClass: "progress-bar",
                                                  style:
                                                    "width: " +
                                                    _vm.uploading[file.name] +
                                                    "%;"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "uploading-list-item-progress"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.uploading[file.name]
                                                  ) + "%"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.uploading[file.name] == 100
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uploading-list-item-speed"
                                                  },
                                                  [_vm._v("Done")]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.rejectedFiles, function(file) {
                                        return _c(
                                          "li",
                                          {
                                            staticClass: "uploading-list-item",
                                            staticStyle: { color: "red" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "uploading-list-item-wrapper"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uploading-list-item-name"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "font-icon font-icon-cam-photo"
                                                    }),
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(file.name) +
                                                        "\n                                                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uploading-list-item-size"
                                                  },
                                                  [_vm._v("Invalid extension")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "uploading-list-item-close",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeFile(
                                                          file.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "font-icon-close-2"
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-upload-bottom" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-rounded btn-secondary btn-sm",
                            attrs: { type: "button" },
                            on: { click: _vm.close }
                          },
                          [_vm._v("Close")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.active
        ? _c("div", { staticClass: "modal-backdrop fade show" })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edb4a5f8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edb4a5f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/UploadModalComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-edb4a5f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/UploadModalComponent.vue
// module chunks = 0